export const OPEN_NOTIFICATION = 'OPEN_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
